<p-dialog
  [header]="currentState.headerText"
  [closable]="true"
  [styleClass]="'common-dialog ' + currentState.styleClass"
  [(visible)]="isDialogVisible"
  [id]="currentState && currentState.selector"
  (onHide)="onHide($event)"
  (onShow)="onShow($event)"
  [responsive]="false"
  [minY]="70"
  [modal]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  [draggable]="true"
>
  <div class="common-dialog__content">
    <p [innerHTML]="currentState.content"></p>
    <p>{{ currentState.description }}</p>
    <div style="margin-top: 10px; margin-bottom: 20px">
      <div *ngIf="!isShowEmailDialog">
        <button class="btn btn-red" id="showEmail" type="button" (click)="showEmailDialog()">
          Получить неоплаченные счета-требования
        </button>
      </div>
      <div *ngIf="isShowEmailDialog">
        <div>
          <label for="email">E-mail:</label>
          <input
            class="input-email"
            type="email"
            pInputText
            [(ngModel)]="mail"
            id="email"
            placeholder="Введите E-mail"
            required
            email
            #email="ngModel"
            autocomplete="off"
            maxlength="256"
          />
          <button
            [disabled]="email.invalid"
            class="btn btn-red"
            style="margin-left: 15px"
            id="sendToEmail"
            type="button"
            (click)="onAccept(mail)"
          >
            Получить
          </button>
        </div>
        <div *ngIf="email.invalid && (email.dirty || email.touched)">
          <div *ngIf="email.errors.required" class="validation-message">
            Пожалуйста, заполните поле.
          </div>
          <div *ngIf="email.errors.email" class="validation-message">
            Пожалуйста, введите валидный e-mail.
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
